
  var _styles = {
  "card-container": {
    "fontFamily": "PingFang SC",
    "background": "#fff",
    "borderRadius": "0.32rem",
    "width": "9.36rem",
    "height": "3.50667rem",
    "padding": "0.24rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "marginBottom": "0.32rem",
    "position": "relative"
  },
  "card-image-view": {
    "width": "3rem",
    "height": "3rem",
    "borderRadius": "0.16rem",
    "overflow": "hidden",
    "position": "relative",
    "flexShrink": 0
  },
  "card-image": {
    "width": "3rem",
    "height": "3rem"
  },
  "card-image-tag": {
    "position": "absolute",
    "width": "0.96rem",
    "height": "0.48rem",
    "left": "0.18667rem",
    "top": "0.24rem",
    "zIndex": 10
  },
  "departures-container": {
    "position": "absolute",
    "left": "1.04rem",
    "top": "0.24rem",
    "zIndex": 9
  },
  "departures-background": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "0.42667rem",
    "zIndex": 11
  },
  "departures-text": {
    "height": "0.42667rem",
    "fontSize": "0.25333rem",
    "color": "rgb(228,225,225)",
    "zIndex": 12,
    "paddingLeft": "0.22667rem",
    "paddingRight": "0.13333rem",
    "lineHeight": "0.42667rem"
  },
  "card-content-right": {
    "flex": 1,
    "width": "100%",
    "height": "3.05333rem",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "boxSizing": "border-box",
    "display": "flex",
    "flexDirection": "column"
  },
  "card-top-field": {
    "width": "100%",
    "display": "flex",
    "paddingTop": 0,
    "paddingRight": "0.24rem",
    "paddingBottom": 0,
    "paddingLeft": "0.24rem"
  },
  "card-tag-field": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row"
  },
  "double-card-day-h5-tag-view": {
    "position": "absolute",
    "top": "0.06667rem",
    "left": 0,
    "textAlign": "center",
    "height": "0.37333rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "borderRadius": "0.08rem",
    "backgroundColor": "rgb(255,209,0)",
    "marginRight": "0.06667rem"
  },
  "double-card-day-h5-tag-text": {
    "color": "rgb(34,0,0)",
    "lineHeight": "0.37333rem",
    "fontWeight": "500",
    "fontSize": "0.26667rem"
  },
  "card-day-tag": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "width": "0.42667rem",
    "height": "0.42667rem",
    "borderRadius": "0.08rem",
    "lineHeight": "0.42667rem",
    "backgroundColor": "rgb(255,209,0)",
    "marginRight": "0.06667rem",
    "overflow": "hidden",
    "marginBottom": "-0.06667rem"
  },
  "card-day-tag-text": {
    "display": "block",
    "height": "0.42667rem",
    "overflow": "hidden",
    "backgroundColor": "rgb(255,209,0)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem"
  },
  "card-day-h5-tag-text": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "paddingTop": "0.05333rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.05333rem",
    "paddingLeft": "0.08rem",
    "backgroundColor": "rgb(255,209,0)",
    "borderRadius": "0.08rem",
    "lineHeight": "0.53333rem",
    "marginRight": "0.06667rem"
  },
  "card-deal-name": {
    "color": "rgb(34,34,33)",
    "fontSize": "0.37333rem",
    "fontWeight": "500",
    "lineHeight": "0.53333rem"
  },
  "card-tag": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "marginTop": "0.16rem",
    "marginRight": 0,
    "marginBottom": "0.16rem",
    "marginLeft": 0,
    "minHeight": "0.37333rem"
  },
  "card-product-tag-group": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(77,153,0,0.2980392157)",
    "marginRight": "0.08rem",
    "whiteSpace": "nowrap",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "minHeight": "0.37333rem"
  },
  "card-product-tag-text-group": {
    "color": "rgb(77,153,0)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "card-people-tag": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(142,60,18,0.2980392157)",
    "marginRight": "0.08rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "minHeight": "0.37333rem"
  },
  "card-people-tag-text": {
    "color": "rgb(142,60,18)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "card-product-tag-free": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(7,119,238,0.2980392157)",
    "marginRight": "0.08rem",
    "whiteSpace": "nowrap",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "minHeight": "0.37333rem"
  },
  "card-product-tag-text-free": {
    "color": "rgb(7,119,238)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "card-bottom-field": {
    "display": "flex",
    "flexDirection": "row",
    "marginTop": "0.18667rem",
    "marginRight": "0.24rem",
    "marginBottom": "0.24rem",
    "marginLeft": "0.24rem",
    "width": "100%",
    "position": "relative",
    "alignItems": "flex-end"
  },
  "card-bottom-left-field": {
    "display": "flex",
    "flexDirection": "column"
  },
  "card-price-field": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "card-price-icon": {
    "color": "rgb(255,39,39)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem",
    "position": "relative",
    "bottom": "0.04rem"
  },
  "card-price-now": {
    "color": "rgb(255,39,39)",
    "fontWeight": "800",
    "fontSize": "0.48rem",
    "position": "relative"
  },
  "card-price-origin": {
    "color": "rgb(102,102,102)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem",
    "textDecoration": "line-through",
    "WebkitTextDecorationColor": "#666",
    "textDecorationColor": "#666",
    "marginBottom": "0.05333rem"
  },
  "card-discount-width-field": {
    "display": "flex",
    "flexDirection": "row"
  },
  "card-discount-left-field": {
    "alignSelf": "flex-start",
    "borderTopLeftRadius": "0.08rem",
    "borderBottomLeftRadius": "0.08rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.37333rem"
  },
  "card-discount-img": {
    "width": "0.37333rem",
    "height": "0.37333rem"
  },
  "card-discount-width-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem"
  },
  "card-discount-right-field": {
    "alignSelf": "flex-start",
    "borderTopRightRadius": "0.08rem",
    "borderBottomRightRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,75,16)",
    "height": "0.37333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "card-curve-img": {
    "width": "0.16rem",
    "height": "0.36rem",
    "marginLeft": "-0.02667rem"
  },
  "card-reduce-text": {
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginRight": "0.08rem"
  },
  "card-discount-field": {
    "display": "flex",
    "flexDirection": "row",
    "alignSelf": "flex-start",
    "borderRadius": "0.08rem"
  },
  "card-discount-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginRight": "0.08rem",
    "marginTop": "0.01333rem"
  },
  "card-bottom-right-field": {
    "borderRadius": "0.4rem",
    "height": "0.8rem",
    "width": "1.38667rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "absolute",
    "right": "0.46667rem",
    "bottom": 0
  },
  "card-bottom-right-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.37333rem",
    "lineHeight": "0.8rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTNewDigitalDisplay-Regular', 'url("https://s3plus.meituan.net/trip-supplier/mcp-static/MTNewDigitalDisplay-Regular.otf") format("opentype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https: //s3plus.meituan.net/trip-supplier/mcp-static/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  